import React from 'react';
import { ColourTheme } from '../../../../types/ColourTheme';
import { convertNumericKeysToArray } from '../../../../newHelpers/convertNumericKeysToArray';
import { personaToAfter } from './PersonaComparisonImageMap';
import { stylize } from '../../../../newHelpers/stylize';
import i18n from 'i18next';
import './PersonaComparison.scss';

type Props = {
  theme: ColourTheme;
};

export const PersonaComparison = (props: Props) => {
  const copy: ComparisonCopy = convertNumericKeysToArray(i18n.t(`${props.theme}Landing.newLife`, { returnObjects: true }));
  const copyTitle = Array.isArray(copy.title) ? copy.title : [copy.title];
  return (
    <div className="PersonaComparison">
      <div className="left-container">
        <div>
          <img src={personaToAfter[props.theme]} alt="anna-after" />
        </div>
      </div>
      <div className="right-container">
        {copyTitle.map((item, key) => <h2 key={key}>{item}</h2>)}
        {copy.p?.map((item, index) =>
          <p key={index}>{stylize(item)}</p>
        )}
      </div>
    </div>
  );
};

type ComparisonCopy = {
  title: string[] | string;
  p: string[];
};
